import { createContext, useContext } from 'react'

/** @type {ReturnType<typeof createContext<google.maps.InfoWindow>>} */
const InfoWindowContext = createContext(null)

export const InfoWindowProvider = InfoWindowContext.Provider

export const useInfoWindowContext = () => useContext(InfoWindowContext)
